import http from "@/utils/http";

/**
 * 认证接口（路径对齐后端 /api/admin/auth/*）
 */

/** 登录 */
export const login = (data: API.LoginRequest) =>
  http.post<API.LoginResult>("/admin/auth/login", data, { silent: true });

/** 登出 */
export const logout = () => http.post<void>("/admin/auth/logout");

/** 刷新 Token */
export const refreshToken = (token: string) =>
  http.post<API.LoginResult>(
    "/admin/auth/refresh",
    { refreshToken: token },
    { silent: true }
  );

/** 获取图形验证码 */
export const getCaptcha = () => http.get<API.Captcha>("/admin/auth/captcha");

/** 获取当前登录用户信息 */
export const getLoginUserInfo = () =>
  http.get<API.LoginUserInfo>("/admin/auth/userinfo");

/** 获取当前用户路由 */
export const getRouters = () =>
  http.get<API.RouterItem[]>("/admin/system/menu/routers");
